export const blockIconsDeviceThermostat = (
	<span className='material-symbols-outlined'>thermostat</span>
);
